module.exports = __webpack_public_path__ + "images/notifications/join-request@2x-eb61f50060e12317dd80d2346be66f16.png";